const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  merchant: state => state.user.merchant,
  permissions: state => state.user.permissions
}
export default getters
